module.exports = __webpack_public_path__ + "img/icon_heart_rate_inactive.c7384678.svg";